import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'glxy-chat-divider-text',
  templateUrl: './chat-divider-text.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./chat-divider-text.component.scss'],
})
export class ChatDividerTextComponent {}
